var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "config",
    attrs: {
      model: _vm.config,
      "label-width": "100px"
    }
  }, [_vm.config.formId ? _c("el-form-item", {
    attrs: {
      label: "当前ID",
      required: true
    }
  }, [_c("el-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.config.formId,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "formId", $$v);
      },
      expression: "config.formId"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "表单标题",
      required: true
    }
  }, [_c("el-input", {
    model: {
      value: _vm.config.title,
      callback: function callback($$v) {
        _vm.$set(_vm.config, "title", $$v);
      },
      expression: "config.title"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };